<template>
    <card class="spaced typo">

        <h2 class="text-white">
            {{ $t('xapi.management.delete-statements.title') }}
        </h2>

        <p>
            {{ $t('xapi.management.delete-statements.description') }}
        </p>

        <context-filters></context-filters>

        <base-button type="primary mt-3" :loading="deleting" @click="deleteStatements">
            {{ $t('xapi.management.delete-statements.button') }}
        </base-button>

        <div class="text-danger pt-2" v-if="errorMessage">
            {{ errorMessage }}
        </div>

        <portal to="modals">
            <modal-confirm v-model="modals.confirmDeleteStatements">
                <p>{{ $t('xapi.management.delete-statements.confirm') }}</p>
            </modal-confirm>
        </portal>

    </card>
</template>

<script>
    import ModalsController from '@trax/classes/ModalsController'

    export default {
    
        data() {
            return {
                filters: this.$xapi.filters.context,
                modals: new ModalsController('confirmDeleteStatements'),
                deleting: false,
                errorMessage: false
            }
        },

        created() {
            this.modals.watch(this, 'modals')
        },

        methods: {

            deleteStatements() {
                this.errorMessage = false
                this.modals.open('confirmDeleteStatements').then(resp => {
                    if (resp.confirmed) {
                        this.deleting = true
                        axios.post(
                            '/trax/api/front/xapi/ext/stores/' + this.$auth.owner.id + '/statements/clear',
                            this.filters.get()
                        )
                        .then(response => {
                            this.deleting = false
                        })
                        .catch(error => {
                            this.deleting = false
                            if (error.response.status == 409) {
                                this.errorMessage = this.$t('xapi.management.delete-statements.conflict')
                            } else {
                                this.errorMessage = this.$t('xapi.management.delete-statements.error')
                                this.$auth.handleErrorVm(error, this)
                            }
                        });
                    }
                })
            }
        }
    }
</script>
